import { Box, HStack, Icon, VStack, makeUclComponent } from '@rbilabs/universal-components';

import { HorizontalPosition } from 'components/features/components/typography-block';
import { MarketingBasicTile } from 'components/marketing-basic-tile';
import { primitive, spacing } from 'styles/constants';
export const InRestaurantRedemptionEntryContainer = makeUclComponent(Box).withConfig<{
  newUI?: boolean;
}>(p => ({
  borderStyle: 'solid',
  borderTopWidth: '1',
  borderColor: primitive.$greyFive,
  borderRadius: p.newUI ? '10px' : null,
  borderWidth: p.newUI ? '1px' : null,
  marginX: p.newUI ? '$4' : null,
  marginBottom: p.newUI ? '$2' : null,
}));

export const InRestaurantRedemptionEntryContent = HStack.withConfig({
  width: 'full',
  alignItems: 'center',
  paddingX: spacing.$0_5,
  paddingY: spacing.$3_5,
});

export const InRestaurantRedemptionList = VStack.withConfig({
  // ul
  margin: '$4',
  padding: '$0',
  borderRadius: 'xl',
  overflow: 'hidden',
});

export const PictureAndDetails = HStack.withConfig({
  flex: 1,
});

export const RewardDetails = VStack.withConfig({
  flex: 1,
  marginLeft: '$4',
  marginRight: '$2',
  justifyContent: 'center',
});

export const WrapperName = VStack.withConfig({
  width: 'full',
  marginBottom: '$2',
});

export const StyledIconX = Icon.withConfig({
  variant: 'cancel',
  color: primitive.$bbqBrown,
  size: 'xs',
  marginLeft: '$2',
});

export const EmptyCartWidgetStyled = MarketingBasicTile.withConfig({
  padding: '$4',
  backgroundColor: primitive.$mayoEggWhite,
  borderRadius: primitive.$borderRadius,
  marginY: '$2',
  marginX: '$4',

  _basicTileTitle: {
    color: primitive.$bbqBrown,
    fontSize: 'lg',
    lineHeight: '2xs',
    textAlign: 'center',
  },
  _typographyBlock: {
    horizontalPosition: HorizontalPosition.CENTER,
    color: primitive.$bbqBrown,
    lineHeight: 'md',
    fontSize: 'md',
    marginY: '$4',
  },
});
